// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1yUj_","image":"Header_image__UsqGl","name":"Header_name__3wL12","info":"Header_info__16UM6","infoRow":"Header_infoRow__2pE7S"};